import React, { useEffect, useMemo, useState } from 'react';
import API_BASE_URL from '../../config/apiConfig';
import superLogo from '../../assets/images/super_logo.webp';
import { getFileUrl } from '../../utils/api';


function NavIcon({ name }) {
  const common = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    className: 'nav-icon__svg',
  };

  switch (name) {
    case 'dashboard':
    case 'accounting-dashboard':
      return (
        <svg {...common}>
          <path d="M12 12V3L4 7v5h8Z" stroke="currentColor" strokeWidth="2" />
          <path d="M12 12h8V7l-8-4v9Z" stroke="currentColor" strokeWidth="2" />
          <path d="M4 12v5l8 4v-9H4Z" stroke="currentColor" strokeWidth="2" />
          <path d="M12 12v9l8-4v-5h-8Z" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'purchase-invoice':
    case 'invoice':
    case 'report-purchase':
    case 'report-sale':
    case 'purchase-order-list':
      return (
        <svg {...common}>
          <path d="M6 3h9l3 3v15H6V3Z" stroke="currentColor" strokeWidth="2" />
          <path d="M15 3v3h3" stroke="currentColor" strokeWidth="2" />
          <path d="M8 11h8M8 15h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'purchase-return':
    case 'sales-return':
      return (
        <svg {...common}>
          <path d="M6 3h9l3 3v15H6V3Z" stroke="currentColor" strokeWidth="2" />
          <path d="M15 3v3h3" stroke="currentColor" strokeWidth="2" />
          <path d="M8 14h5a2 2 0 0 0 2-2V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M11 17l-3-3 3-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'purchase-challan':
    case 'sales-challan':
    case 'report-purchase-challan':
    case 'report-sale-challan':
      return (
        <svg {...common}>
          <rect x="2" y="10" width="14" height="8" stroke="currentColor" strokeWidth="2" />
          <path d="M16 12h4l2 2v4h-6v-6Z" stroke="currentColor" strokeWidth="2" />
          <circle cx="5" cy="20" r="2" stroke="currentColor" strokeWidth="2" />
          <circle cx="18" cy="20" r="2" stroke="currentColor" strokeWidth="2" />
          <path d="M2 13h14" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'in-stock':
      return (
        <svg {...common}>
          <path d="M4 7h16v14H4V7Z" stroke="currentColor" strokeWidth="2" />
          <path d="M8 7V5h8v2" stroke="currentColor" strokeWidth="2" />
          <path d="M12 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M9 14l3-3 3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'out-stock':
      return (
        <svg {...common}>
          <path d="M4 7h16v14H4V7Z" stroke="currentColor" strokeWidth="2" />
          <path d="M8 7V5h8v2" stroke="currentColor" strokeWidth="2" />
          <path d="M12 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M9 13l3 3 3-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'seller':
      return (
        <svg {...common}>
          <path d="M16 11a4 4 0 1 0-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M17 8h3M18.5 6.5v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'customer':
      return (
        <svg {...common}>
          <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" stroke="currentColor" strokeWidth="2" />
          <path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'transporter':
      return (
        <svg {...common}>
          <path d="M3 7h11v10H3V7Z" stroke="currentColor" strokeWidth="2" />
          <path d="M14 10h4l3 3v4h-7v-7Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M7 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" stroke="currentColor" strokeWidth="2" />
          <path d="M18 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'account':
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></rect>
          <line x1="7" y1="8" x2="17" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></line>
          <line x1="7" y1="12" x2="17" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></line>
          <line x1="7" y1="16" x2="11" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></line>
        </svg>
      );
    case 'product':
      return (
        <svg {...common}>
          <path d="M12 3l8 4-8 4-8-4 8-4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M4 7v10l8 4 8-4V7" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M12 11v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'category':
      return (
        <svg {...common}>
          <path d="M5 5h6v6H5V5Z" stroke="currentColor" strokeWidth="2" />
          <path d="M13 5h6v6h-6V5Z" stroke="currentColor" strokeWidth="2" />
          <path d="M5 13h6v6H5v-6Z" stroke="currentColor" strokeWidth="2" />
          <path d="M13 13h6v6h-6v-6Z" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'bank':
      return (
        <svg {...common}>
          <path d="M3 21h18M3 10h18M5 21v-11M9 21v-11M15 21v-11M19 21v-11M3 10l9-7 9 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'company':
      return (
        <svg {...common}>
          <path d="M3 21h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M5 21V7l7-4 7 4v14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 21V11h6v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'expenses':
    case 'report-expense':
      return (
        <svg {...common}>
          <path d="M12 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M17 7c0-2-2-3-5-3S7 5 7 7s2 3 5 3 5 1 5 3-2 3-5 3-5-1-5-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'user':
      return (
        <svg {...common}>
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'plan':
      return (
        <svg {...common}>
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'plan-payment':
      return (
        <svg {...common}>
          <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="12" cy="15" r="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'coupon':
      return (
        <svg {...common}>
          <path d="M15 5l-10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M21 7.5a2.5 2.5 0 0 0-2.5-2.5H16l-3-3v3.5l-3-3v3.5H3.5A2.5 2.5 0 0 0 1 7.5v9A2.5 2.5 0 0 0 3.5 19H7l3 3v-3.5l3 3v-3.5h2.5a2.5 2.5 0 0 0 2.5-2.5v-9z" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'chat':
      return (
        <svg {...common}>
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'voucher-list':
    case 'voucher-group':
    case 'voucher-type':
    case 'report-payment':
      return (
        <svg {...common}>
          <path d="M4 4h16v16H4V4Z" stroke="currentColor" strokeWidth="2" />
          <path d="M4 8h16M4 12h16M4 16h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M8 4v16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'report':
      return (
        <svg {...common}>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" />
          <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" />
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" />
          <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" />
          <polyline points="10 9 9 9 8 9" stroke="currentColor" strokeWidth="2" />
        </svg>
      );

    case 'report-gst':
      return (
        <svg {...common}>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" />
          <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" />
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" />
          <text x="7" y="17" fontSize="4.5" fontWeight="bold" fill="currentColor" stroke="none">GST</text>
        </svg>
      );    case 'master':
      return (
        <svg {...common}>
          <path d="M4 4h6v6H4V4Z" stroke="currentColor" strokeWidth="2" />
          <path d="M14 4h6v6h-6V4Z" stroke="currentColor" strokeWidth="2" />
          <path d="M4 14h6v6H4v-6Z" stroke="currentColor" strokeWidth="2" />
          <path d="M14 14h6v6h-6v-6Z" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    case 'chat-dropdown':
      return (
        <svg {...common}>
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'report-purchase':
      return (
        <svg {...common}>
          <path d="M6 3h9l3 3v15H6V3Z" stroke="currentColor" strokeWidth="2" />
          <path d="M15 3v3h3" stroke="currentColor" strokeWidth="2" />
          <path d="M8 11h8M8 15h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'report-sale':
      return (
        <svg {...common}>
          <path d="M6 3h9l3 3v15H6V3Z" stroke="currentColor" strokeWidth="2" />
          <path d="M15 3v3h3" stroke="currentColor" strokeWidth="2" />
          <path d="M8 11h8M8 15h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'outstanding':
      return (
        <svg {...common}>
          <path d="M16 7a3 3 0 11-6 0 3 3 0 016 0zM12 14v7m-4-2h8m-9-9l-3 3m12-3l3 3M4 14l2-2m14 2l-2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'receivable':
    case 'payable':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    default:
      if (name && name.startsWith('v-')) {
        return (
          <svg {...common} viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
          </svg>
        );
      }
      return (
        <svg {...common} viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
  }
}

function Sidebar({
  companyLogo,
  companyName,
  isOpen,
  isCollapsed,
  isSuperAdmin,
  onToggleCollapsed,
  onClose,
  items,
  settingsItems,
  activeKey,
  onSelect,
}) {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [openItems, setOpenItems] = useState({});

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  const isSettingsActive = useMemo(
    () => settingsItems.some((i) => i.key === activeKey),
    [settingsItems, activeKey]
  );

  useEffect(() => {
    if (isSettingsActive) setSettingsOpen(true);
  }, [isSettingsActive]);

  // Handle nested items
  const toggleItemOpen = (key) => {
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen ? 'sidebar-overlay--open' : ''}`}
        onClick={onClose}
      />

      <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''} ${isCollapsed ? 'sidebar--collapsed' : ''}`}>
        <div className="sidebar__top">
          <div
            className="sidebar__brand"
            onClick={() => {
              if (isCollapsed) onToggleCollapsed();
              onSelect('/welcome');
            }}
            style={{ cursor: 'pointer' }}
          >
            <img
              className="sidebar__logo"
              src={companyLogo ? getFileUrl(companyLogo) : superLogo}
              alt={isSuperAdmin ? "Super Admin Logo" : (companyName || "Asencia Logo")}
            />
            {!isCollapsed && <div className="sidebar__brandText">
              <div className="sidebar__brandName">{companyName || "Asencia"}</div>
            </div>}
          </div>

          <div className="sidebar__topActions">
            <button
              type="button"
              className="icon-btn sidebar__toggle"
              onClick={onToggleCollapsed}
              aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
              {isCollapsed ? '›' : '‹'}
            </button>

            <button type="button" className="icon-btn sidebar__close" onClick={onClose} aria-label="Close sidebar">
              ✕
            </button>
          </div>
        </div>

        <nav className="sidebar__nav" aria-label="Sidebar navigation">
          {items.map((group, gIdx) => (
            <div key={gIdx} className="nav-group">
              {group.label && <div className="sidebar-sectionLabel">{group.label}</div>}
              {group.items.map((item) => {
                const isItemOpen = openItems[item.key] || item.children?.some(child => child.key === activeKey);

                return (
                  <div key={item.key} className="nav-item-wrapper">
                    <button
                      type="button"
                      className={`nav-item ${activeKey === item.key ? 'nav-item--active' : ''} ${item.children ? 'nav-item--parent' : ''} ${item.children && isItemOpen ? 'nav-item--expanded' : ''}`}
                      onClick={() => {
                        if (item.children) {
                          toggleItemOpen(item.key);
                        } else {
                          onSelect(item.key);
                        }
                      }}
                      title={item.label}
                    >
                      <span className="nav-icon" aria-hidden="true">
                        <NavIcon name={item.key} />
                      </span>
                      <span className="nav-label">{item.label}</span>
                      {item.badge > 0 && (
                        <span className="nav-badge">{item.badge}</span>
                      )}
                      {item.children && !isCollapsed && (
                        <span className="nav-chev" aria-hidden="true">
                          {isItemOpen ? '▾' : '▸'}
                        </span>
                      )}
                    </button>

                    {item.children && isItemOpen && !isCollapsed && (
                      <div className="nav-sub">
                        {item.children.map(child => (
                          <button
                            key={child.key}
                            type="button"
                            className={`nav-subitem ${activeKey === child.key ? 'nav-subitem--active' : ''}`}
                            onClick={() => onSelect(child.key)}
                          >
                            <span className="nav-icon" aria-hidden="true">
                              <NavIcon name={child.key} />
                            </span>
                            <span className="nav-subitem-label">{child.label}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}



          {settingsItems.length > 0 && (
            <div className="nav-group">
              <div className="sidebar-sectionLabel">SETTINGS</div>

              <button
                type="button"
                className={`settings-head ${settingsOpen ? 'settings-head--open' : ''}`}
                onClick={() => setSettingsOpen((v) => !v)}
                aria-expanded={settingsOpen}
                title="Settings"
              >
                <span className="settings-head__left">
                  <span className="settings-head__icon" aria-hidden="true">⚙</span>
                  <span className="settings-head__text">Settings</span>
                </span>

                <span className="settings-head__chev" aria-hidden="true">▾</span>
              </button>

              <div className={`settings-list ${settingsOpen ? 'settings-list--open' : ''}`}>
                {settingsItems.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    className={`settings-item ${activeKey === item.key ? 'settings-item--active' : ''}`}
                    onClick={() => onSelect(item.key)}
                    title={item.label}
                  >
                    <span className="settings-item__dot" aria-hidden="true" />
                    <span className="settings-item__label">{item.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
